export default __webpack_public_path__ + "static/media/images_trophy.70ffc0c0.png";